module.exports = __webpack_public_path__ + "static/media/crybanners_sm2.e79e0921.jpg";